import { getDefaultExportFromCjs as M } from "./atoms-v2801.js";
import { __exports as w } from "./atoms-v21003.js";
import N from "./atoms-v21004.js";
import _ from "./atoms-v21005.js";
import "./atoms-v21006.js";
import { __exports as v } from "./atoms-v21007.js";
(function(t) {
  const S = N, b = _, $ = v.remove, u = {}, l = {}, s = {}, f = {}, p = {};
  S.forEach(function(e) {
    const r = e;
    l[r[0]] = r[1], s[r[1]] = r[0], f[r[2]] = r[0], p[r[0]] = r[2];
  });
  function C(e) {
    return ("000" + (e || "")).slice(-3);
  }
  function c(e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }
  function E(e, r) {
    return Object.keys(e).reduce(function(i, a) {
      const n = e[a];
      return i[a] = r(n, a), i;
    }, {});
  }
  function y(e, r) {
    switch (e) {
      case "official":
        return Array.isArray(r) ? r[0] : r;
      case "all":
        return typeof r == "string" ? [r] : r;
      case "alias":
        return Array.isArray(r) ? r[1] || r[0] : r;
      default:
        throw new TypeError(
          "LocaleNameType must be one of these: all, official, alias!"
        );
    }
  }
  t.registerLocale = function(e) {
    if (!e.locale)
      throw new TypeError("Missing localeData.locale");
    if (!e.countries)
      throw new TypeError("Missing localeData.countries");
    u[e.locale] = e.countries;
  };
  function h(e) {
    return s[e];
  }
  t.alpha3ToAlpha2 = h;
  function m(e) {
    return l[e];
  }
  t.alpha2ToAlpha3 = m;
  function O(e) {
    return p[h(e)];
  }
  t.alpha3ToNumeric = O;
  function U(e) {
    return p[e];
  }
  t.alpha2ToNumeric = U;
  function d(e) {
    const r = C(e);
    return m(f[r]);
  }
  t.numericToAlpha3 = d;
  function g(e) {
    const r = C(e);
    return f[r];
  }
  t.numericToAlpha2 = g;
  function j(e) {
    if (typeof e == "string") {
      if (/^[0-9]*$/.test(e))
        return d(e);
      if (e.length === 2)
        return m(e.toUpperCase());
      if (e.length === 3)
        return e.toUpperCase();
    }
    if (typeof e == "number")
      return d(e);
  }
  t.toAlpha3 = j;
  function T(e) {
    if (typeof e == "string") {
      if (/^[0-9]*$/.test(e))
        return g(e);
      if (e.length === 2)
        return e.toUpperCase();
      if (e.length === 3)
        return h(e.toUpperCase());
    }
    if (typeof e == "number")
      return g(e);
  }
  t.toAlpha2 = T, t.getName = function(e, r, i = {}) {
    "select" in i || (i.select = "official");
    try {
      const n = u[r.toLowerCase()][T(e)];
      return y(i.select, n);
    } catch {
      return;
    }
  }, t.getNames = function(e, r = {}) {
    "select" in r || (r.select = "official");
    const i = u[e.toLowerCase()];
    return i === void 0 ? {} : E(i, function(a) {
      return y(r.select, a);
    });
  }, t.getAlpha2Code = function(e, r) {
    const i = (n) => n.toLowerCase(), a = (n, o) => i(n) === i(o);
    try {
      const n = u[r.toLowerCase()];
      for (const o in n)
        if (c(n, o)) {
          if (typeof n[o] == "string" && a(n[o], e))
            return o;
          if (Array.isArray(n[o])) {
            for (const A of n[o])
              if (a(A, e))
                return o;
          }
        }
      return;
    } catch {
      return;
    }
  }, t.getSimpleAlpha2Code = function(e, r) {
    const i = (n) => $(n.toLowerCase()), a = (n, o) => i(n) === i(o);
    try {
      const n = u[r.toLowerCase()];
      for (const o in n)
        if (c(n, o)) {
          if (typeof n[o] == "string" && a(n[o], e))
            return o;
          if (Array.isArray(n[o])) {
            for (const A of n[o])
              if (a(A, e))
                return o;
          }
        }
      return;
    } catch {
      return;
    }
  }, t.getAlpha2Codes = function() {
    return l;
  }, t.getAlpha3Code = function(e, r) {
    const i = t.getAlpha2Code(e, r);
    if (i)
      return t.toAlpha3(i);
  }, t.getSimpleAlpha3Code = function(e, r) {
    const i = t.getSimpleAlpha2Code(e, r);
    if (i)
      return t.toAlpha3(i);
  }, t.getAlpha3Codes = function() {
    return s;
  }, t.getNumericCodes = function() {
    return f;
  }, t.langs = function() {
    return Object.keys(u);
  }, t.getSupportedLanguages = function() {
    return b;
  }, t.isValid = function(e) {
    if (!e)
      return !1;
    const r = e.toString().toUpperCase();
    return c(s, r) || c(l, r) || c(f, r);
  };
})(w);
const B = /* @__PURE__ */ M(w);
export {
  B as default
};
